import { render } from "./ApeConstructorBodyType.vue?vue&type=template&id=348b2740"
import script from "./ApeConstructorBodyType.vue?vue&type=script&lang=js"
export * from "./ApeConstructorBodyType.vue?vue&type=script&lang=js"

import "./ApeConstructorBodyType.vue?vue&type=style&index=0&id=348b2740&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__